package com.playoffpulse.frontend

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.renderComposable
import com.playoffpulse.frontend.ui.PlayoffPulseApp

fun main() {
    renderComposable(rootElementId = "root") {
        Root()
    }
}

@Composable
private fun Root() {
    PlayoffPulseApp()
}
